<template>
  <modal v-model="isVisible">
    <div class="c-modalCard">
      <header class="c-modalCard__header">
        <h4 class="c-modalCard__title">Detalhes do histórico - {{ log.identifier }}</h4>
        <a role="button" class="c-modalCard__close" v-on:click="isVisible = false">
          <i class="i-remove"></i>
        </a>
      </header>

      <div class="c-modalCard__body">
        <div class="l-row code-container">
          <div class="l-col-10@md">
            <vue-json-pretty :data="log.privateData"/>
          </div>

          <div class="l-col-2@md u-textRight">
            <button type="button" class="btn btn--success" v-clipboard:copy="JSON.stringify(log.privateData)">
              <i class="icon icon-copy2"></i>
            </button>
          </div>
        </div>

      </div>

      <footer class="c-modalCard__footer">
        <button type="button" class="btn btn--info" v-on:click="cancel()">Fechar</button>
      </footer>
    </div>
  </modal>
</template>

<script>
  import VueJsonPretty from 'vue-json-pretty'

  export default {
    data: () => ({
      modal: null,
      isVisible: false
    }),
    props: {
      value: {
        type: Boolean,
        required: true
      },
      log: {
        type: Object,
        required: true
      }
    },
    created () {
      this.isVisible = this.value
    },
    mounted () {
      this.modal = document.querySelector('div.c-modal')
      this.modal.onclick = (event) => {
        if (event.target === this.modal) {
          this.close()
        }
      }
      document.body.onkeyup = (event) => {
        if (event.code === 'Escape') {
          this.close()
        }
      }
    },
    methods: {
      confirm () {
        this.$emit('option', true)
        this.close()
      },
      cancel () {
        this.close()
      },
      close (emit) {
        delete document.body.onkeyup
        delete this.modal.onclick

        this.isVisible = false
      }
    },
    watch: {
      isVisible (value) {
        this.$emit('input', value)
      },
      value (value) {
        this.isVisible = value
      }
    },
    components: {
      VueJsonPretty
    }
  }
</script>

<style lang="sass" scoped>
  .code-container
    padding: 10px 0
    background: #f5f7fa
    color: #69707a
    font-size: 12px
    overflow-x: scroll
</style>

<style lang="sass">
  .c-modal__content
    max-width: 850px
</style>



// WEBPACK FOOTER //
// LogModal.vue?00a59d16